export * from "modules/BrandsDashboard/components/BrandsDashboardTable/components/BrandGroupBrandsTable";
